import router from './router'
import { getToken } from '@/utils/myAuth' // get token from cookie

const whiteList = ['/login', '/appRepair', '/appRepairApplication', '/appRepairSearch', '/appRepairApplication/success']
router.beforeEach(async(to, from, next) => {
  const hasToken = getToken()
  if (hasToken) { // 如果存在token 不跳转到登录页 重定向到首页
    if (to.path === '/login') { // 如果跳转页为login 重定向到home页
      next({ path: '/' })
    } else { // 如果跳转的为其他页，直接放行
      if (to.path === '/appRepairApplication/success') {
        if (from.path !== '/appRepairApplication') {
          next({ path: '/appRepair' })
        } else {
          next()
        }
      } else {
        next()
      }
    }
  } else { // 如果没有token 跳转到登录页
    if (whiteList.indexOf(to.path) !== -1) { // 如果to.path没有在白名单内
      next()
    } else {
      next(`/login?redirect=${to.path}`)
    }
  }
})

